import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import format from '../../helpers/format'
import {
  Grade,
  Link,
  LinkIcon
} from '../'
import Styles from './ExclusionsGradeBox.css'


@CSSModules(Styles, {allowMultiple:true})
export default class ExclusionsGradeBox extends Component {
  static propTypes = {
    grade: PropTypes.number.isRequired,
    issueId: PropTypes.string.isRequired
  }
  constructor(props){
    super(props)

    const linkText = {
      pff: 'prisons & borders',
      wff: 'military weapons',
    }[this.props.issueId] || ''

    const linkTitle = {
      pff: 'Prisons & borders methodology',
      wff: 'Military weapons methodology',
    }[this.props.issueId] || 'Methodology'

    const linkUrl = {
      pff: 'https://prisonfreefunds.org/how-it-works',
      wff: 'https://weaponfreefunds.org/how-it-works',
    }[this.props.issueId] || 'https://investyourvalues.org/methodology'

    this.state = {
      linkText,
      linkTitle,
      linkUrl
    }
  }
  //
  render() {
    return <div styleName='exclusions-grade-box'>

      <h3 styleName='exclusions-grade-box__title'>
        Grade
      </h3>

      <div styleName='exclusions-grade-box__grade'>
        <div styleName='exclusions-grade-box__grade-inner'>
          <Grade grade={this.props.grade} square />
        </div>
      </div>

      <p styleName='exclusions-grade-box__link'>
        <Link strong title={this.state.linkTitle} to={this.state.linkUrl}>
          Methodology<LinkIcon/>
        </Link>
      </p>

    </div>
  }
}

